module.exports = __webpack_public_path__ + "img/洋河追溯体系.937a661d.jpg";